const DOWNLOAD_FILE_FROM_DATABASE = {
	JPEG_IMAGE: "image/jpeg",
	JPG_IMAGE: "image/jpg",
	PNG_IMAGE: "image/png",
	TEXT_FILE: "text/plain",
	DOC_FILE: "application/msword",
	DOCX_FILE: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	XLS_FILE: "application/vnd.ms-excel",
	XLSX_FILE: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	PDF: "application/pdf"
};

export default DOWNLOAD_FILE_FROM_DATABASE;
